export default {
    layout : {
        carregando: 'Carregando...'
    }
}